import { USER_DB_REF } from "../constants/firestore";
import theme from "../core/theme";
import { Calculation } from "../types/calculation";
import { firestoreBuildQuery, firestoreCollectionRead, firestoreExecuteQuery, firestoreLimit, firestoreOrderBy } from "./common/firebase";

export async function loadCalculationHistory(
  uid: string
): Promise<Calculation[]> {
  let res: Calculation[] = [];
  const query = firestoreBuildQuery(
    `${USER_DB_REF}/${uid}/calculationHistory`,
    firestoreOrderBy('tsCreated'),
    firestoreLimit(30)
  );
  const querySnap = await firestoreExecuteQuery(query);
  querySnap.forEach(el => res.push(el.data() as Calculation));
  return res;
}

export function getCalculationResultRange(
  calculationResult: number
): string {
  if (calculationResult >= 89) return 'OTTIMO';
  else if (calculationResult >= 76 && calculationResult < 89) return 'BUONO';
  else if (calculationResult >= 60 && calculationResult < 76) return 'SUFFICIENTE';
  return 'INSUFFICIENTE';
}

export function getCalculationResultColor(
  calculationResult: number
): string {
  if (calculationResult >= 89) return theme.color.success;
  else if (calculationResult >= 76 && calculationResult < 89) return '#FAC610';
  else if (calculationResult >= 60 && calculationResult < 76) return '#FF839B';
  return theme.color.error;
}